import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from 'src/app/utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class RecipientMaintenanceService {

  constructor(
    private http: HttpService,
  ) { }
  
  getList(data?: any) {
    return this.http.post(Path.RECIPIENT.GET_LIST, data);
  }
  
  getDetail(params?: any) {
    return this.http.get(Path.RECIPIENT.GET_DETAIL, params);
  }
    
  insert(data?: any) {
    return this.http.post(Path.RECIPIENT.INSERT, data);
  }

  genericMaintenanceDownload(data?: any) {
    return this.http.post(Path.DOWNLOAD.DOWNLOAD_RECIPIENT_MAINTENACE, data);
  }

  downloadQR(data?: any) {
    return this.http.post(Path.DOWNLOAD.DOWNLOAD_RECIPIENT_QR, data);
  }

  bulkDownloadQR(data?: any) {
    return this.http.post(Path.RECIPIENT_GENERATE_QR.BULK_DOWNLOAD, data);
  }

  couponBulkDownloadQR(data?: any) {
    return this.http.post(Path.PATIENT_GENERATE_QR.BULK_DOWNLOAD, data);
  }

  getListTypes() {
    return this.http.post(Path.RECIPIENT.GET_RECIPIENT_TYPE_LIST);
  }

  getWebUserList(data?: any) {
    return this.http.post(Path.RECIPIENT.WEB_USER_FILTER, data);
  }
}
